import { useTranslation } from "react-i18next";

const SenseProfileSlide = () => {
  const { t } = useTranslation();

  return (
    <h2 className="font-serif font-light text-[52px] text-white leading-[86px] tracking-[0px] lg:text-[45px] lg:leading-[45px] md:text-[40px] md:leading-[40px] sm:text-[30px] sm:leading-[30px] sm:-tracking-[.5px] xs:text-[30px] xs:leading-[30px]">
      <span className="font-semibold block">
        {t("page.main.slider.1.firsttitle")}
        <br />
        <span className="text-[#01FFFF]">
          {t("page.main.slider.1.secondtitle")}
        </span>
      </span>
    </h2>
  );
};

export default SenseProfileSlide;
